import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { initialized, user } = useAuth();
  // While auth is initializing, render nothing (avoids redirect races on reload)
  if (!initialized) return null;
  // If initialized but not authenticated, redirect to sign-in
  if (!user) return <Navigate to="/" replace />;
  // Authenticated: render children
  return <>{children}</>;
}
